import React from 'react';
import PropTypes from 'prop-types';
import IconChevronLeft from '@spothero/icons/chevron-left';
import IconChevronRight from '@spothero/icons/chevron-right';
import Button from '@spothero/ui/button';

const PhotosCardPanelArrow = ({direction, className, onClick}) => {
    return (
        <Button className={className} onClick={onClick}>
            {direction === 'left' ? <IconChevronLeft /> : <IconChevronRight />}
        </Button>
    );
};

PhotosCardPanelArrow.propTypes = {
    className: PropTypes.string,
    direction: PropTypes.oneOf(['left', 'right']).isRequired,
    onClick: PropTypes.func,
};

export default PhotosCardPanelArrow;
